import React from 'react';
import FireflyEffect from '../components/FireflyEffect';
import AboutCarousel from '../components/AboutCarousel';
//import '../styles/AboutPage.css';
import { Helmet } from "react-helmet-async";

function AboutPage() {
  
  const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://grauconejo13-portfolio-backend.netlify.app"
    : "http://localhost:8888";

  return (
    
    <div className="about-page-wrapper">
    
    <Helmet>
  <title>About | Vanessa Victorino</title>
  <meta
    name="description"
    content="From healthcare to full-stack software — my journey blends systems thinking, creative instinct, and deep curiosity for how things work (and feel)."
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph */}
  <meta property="og:title" content="Meet Vanessa Victorino | Developer & Designer" />
  <meta
    property="og:description"
    content="A hybrid thinker at heart — passionate about tech, design, psychology, and building things that resonate."
  />
  <meta property="og:url" content={`${baseUrl}/about`} />
  <meta property="og:type" content="profile" />
  <meta property="og:image" content={`${baseUrl}/preview-about.jpg`} />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="About Vanessa Victorino" />
  <meta
    name="twitter:description"
    content="Learn more about my journey, creative philosophy, and the skills I’m constantly refining."
  />
  <meta name="twitter:image" content={`${baseUrl}/twitter-about.jpg`} />
</Helmet>

      <FireflyEffect />
      <main className="about-content">
        <AboutCarousel />
      </main>
    </div>
  );
}

export default AboutPage;
